module.exports = __webpack_public_path__ + "static/media/occasions-main.1ce71dde.jpg";